import React from 'react';

import { Row, Button, Table } from 'antd';
// import { useTheme } from 'utils/Theme';
import { User } from 'models/User';
import { USER_TYPE } from 'types/Enum';

import { UserManagementGeneratedProps } from './UserManagement.props';
import {
  Container,
  StyledSpace,
  Badge,
  ButtonRow,
} from './UserManagement.style';

const UserManagementView = (
  props: UserManagementGeneratedProps
): JSX.Element => {
  // const theme = useTheme();

  return (
    <Container>
      <StyledSpace direction="vertical" size={16}>
        <Row justify="end">
          <Button type="primary" onClick={props.onClickAddUser}>
            Add User
          </Button>
        </Row>
        <Table
          loading={props.isFetching}
          dataSource={props.users}
          // onChange={props.onChange}
          rowKey="id"
        >
          <Table.Column title="Email" dataIndex="email" />

          <Table.Column
            title="Active"
            dataIndex={'type' as keyof User}
            render={(type: USER_TYPE) => {
              return (
                <Badge type={type}>
                  {type === 'CONSULTANT' ? 'Active' : 'Disabled'}
                </Badge>
              );
            }}
          />

          <Table.Column
            title="Actions"
            render={({ id, type }: User) => {
              return (
                <ButtonRow>
                  <Button
                    style={{ marginRight: '16px' }}
                    type="primary"
                    onClick={() =>
                      type === 'CONSULTANT'
                        ? props.onRemoveAccess(id)
                        : props.onGiveAccess(id)
                    }
                  >
                    {type === 'CONSULTANT' ? 'Disable' : 'Reactivate'}
                  </Button>

                  <Button
                    type="primary"
                    danger
                    onClick={() => props.onDeleteUser(id)}
                  >
                    Delete
                  </Button>
                </ButtonRow>
              );
            }}
          />
        </Table>
      </StyledSpace>
    </Container>
  );
};

export default UserManagementView;
